import {
  MainnetLegacyMarketAddress,
  MainnetTokenAddress,
} from "@silo/addresses";
import { ChecksumAddress, ProtocolKey } from "@silo/types";
import { isNullable } from "effect/Predicate";

const XAI_ASSET_ADDRESS: Record<ProtocolKey, ChecksumAddress | null> = {
  mainnetLegacy: MainnetTokenAddress.XAI,
  mainnetLlama: null,
  mainnetGrand: null,
  arbitrum: null,
  optimism: null,
  base: null,
  lrtbase: null,
  local: null,
  anvil: MainnetTokenAddress.XAI,
};

export function getIsXaiAsset(
  protocolKey: ProtocolKey,
  assetAddress: ChecksumAddress
): boolean {
  const xaiAssetAddress = XAI_ASSET_ADDRESS[protocolKey];

  if (isNullable(xaiAssetAddress)) return false;

  return xaiAssetAddress === assetAddress;
}

const XAI_MARKET_ADDRESS: Record<ProtocolKey, ChecksumAddress | null> = {
  mainnetLegacy: MainnetLegacyMarketAddress.XAI,
  mainnetLlama: null,
  mainnetGrand: null,
  arbitrum: null,
  optimism: null,
  base: null,
  lrtbase: null,
  local: null,
  anvil: MainnetLegacyMarketAddress.XAI,
};

export function getIsXaiMarket(
  protocolKey: ProtocolKey,
  marketAddress: ChecksumAddress
): boolean {
  const xaiMarketAddress = XAI_MARKET_ADDRESS[protocolKey];

  if (isNullable(xaiMarketAddress)) return false;

  return xaiMarketAddress === marketAddress;
}
